import PropTypes from 'prop-types'
import { ReactComponent as ErrorSvg } from '../../../assets/svg/error.svg'

const ErrorToast = ({ message, className = '' }) => {
  if (!message) return null

  return (
    <div
      role='alert'
      className={`d-flex align-items-center gap-2 rounded ${className}`}
      style={{
        background: '#FCEAEA',
        padding: '12px 8px',
        boxShadow: '0px 4px 8px 0px #1018281A, 0px 2px 4px 0px #1018280F',
      }}
    >
      <ErrorSvg width={20} height={20} style={{ flexShrink: 0 }} />
      <p
        className='small fw-medium mb-0'
        style={{ color: '#7C0000', display: 'block' }}
      >
        {message}
      </p>
    </div>
  )
}

ErrorToast.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
}

export default ErrorToast
